import React from "react";

export const Eye = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 15 15"
    >
      <path
        fillRule="evenodd"
        d="M7 2.298c4.384 0 6.84 4.784 6.956 5.017a.643.643 0 010 .467c-.117.233-2.572 5.016-6.956 5.016-4.127 0-6.544-4.237-6.911-4.881a2 2 0 00-.045-.077.808.808 0 010-.525C.16 7.082 2.616 2.298 7 2.298zm-5.787 5.25c.584.934 2.63 4.084 5.787 4.084s5.203-3.15 5.787-4.084c-.585-.933-2.63-4.083-5.787-4.083s-5.261 3.15-5.787 4.083zM7 5.215a2.343 2.343 0 00-2.338 2.333A2.343 2.343 0 007 9.882a2.343 2.343 0 002.338-2.334A2.343 2.343 0 007 5.215zM5.83 7.548c0 .642.527 1.167 1.17 1.167.643 0 1.17-.525 1.17-1.167 0-.641-.527-1.166-1.17-1.166-.643 0-1.17.525-1.17 1.166z"
        clipRule="evenodd"
      />
    </svg>
  );
};
